import { useMutation } from '@tanstack/react-query';
import { useMe } from 'state/Administrators';
import { loaders } from './ai-translate.loaders';

export const useTranslateText = () => {
  const { isMelpAdmin } = useMe();

  return useMutation(
    (data: Parameters<typeof loaders.translateText>[0]['data']) =>
      loaders.translateText({
        context: isMelpAdmin ? 'melp' : 'admin',
        data,
      }),
  );
};
